import React from 'react';

function Article() {
  return (
    <div className="video-article">
      <h3>Cajero automático</h3>
      <p>Conocé cómo operar en el cajero automático</p>
      <div className="embed-container">
        <div className='embed-responsive embed-responsive-16by9 with-curves'>
          <iframe width="560" height="315" src="https://www.youtube.com/embed/koywVQP11sI?si=fAbOCKnXXeF2pyA-" title="Conocé cómo operar en el cajero automático" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerPolicy="strict-origin-when-cross-origin" allowFullScreen></iframe>
        </div>
      </div>
    </div>
  );
}

export default Article;